import { createContext, useContext, useState, useCallback } from "react";

const AlertContext = createContext();

export const useAlert = () => useContext(AlertContext);

/**
 * AlertProvider — Fournit un bandeau d'alerte global accessible depuis n'importe où,
 * y compris depuis l'interceptor axios (via alertBridge).
 *
 * Usage : showAlert("success" | "error" | "warning", "message", durationMs?)
 */
export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null); // { type, message }

  const showAlert = useCallback((type, message, duration = 5000) => {
    setAlert({ type, message });
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (duration > 0) {
      setTimeout(() => setAlert(null), duration);
    }
  }, []);

  const hideAlert = useCallback(() => setAlert(null), []);

  // Brancher le bridge pour l'interceptor axios
  alertBridge.showAlert = showAlert;

  return (
    <AlertContext.Provider value={{ alert, showAlert, hideAlert }}>
      {children}
    </AlertContext.Provider>
  );
};

/**
 * alertBridge — pont statique pour appeler showAlert depuis l'interceptor axios
 * (qui n'est pas un composant React et ne peut pas utiliser useContext).
 */
export const alertBridge = {
  showAlert: null,
};
